
import FeatureSection from './FeatureSection';
import HeroPage from './Heropage';
import ProjectSlider from './ProjectSlider';
import Services from './Services';
import WelcomeSection from './WelcomeSection';
import WhyChooseUs from './WhyChooseUs';

const Home = () => {
  return (
    <>
    <HeroPage />
    <WelcomeSection />
    <ProjectSlider />
    <FeatureSection />
    <Services />
    <WhyChooseUs />
    
    
     
    </>
  );
};

export default Home;
